import React, { useEffect, useState } from 'react'
import { Dropdown, Layout, Menu } from 'antd'
import {
  UserOutlined,
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined
} from '@ant-design/icons'
import { useLocation } from 'react-router-dom'
import { titleMap } from '../../configData'

const { Header: HeaderAntd } = Layout

export default function Header({ isCollapsed, setIsCollapsed, onLogout }) {
  const [username] = useState(localStorage.getItem('user_name'))
  const [title, setTitle] = useState('');
  const location = useLocation()

  useEffect(() => {
    setTitle(titleMap[location.pathname])
  }, [location.pathname])
  const menu = (
    <Menu>
      <Menu.Item key="logout" icon={<LogoutOutlined />} onClick={onLogout}>
        Đăng xuất
      </Menu.Item>
    </Menu>
  )

  return (
    <HeaderAntd
      style={{ background: '#fff', padding: 0, alignItems: 'baseline' }}
      className="flex flex-start"
    >
      <div
        className="pl-4 cursor-pointer"
        onClick={() => {
          const _isCollapsed = !isCollapsed

          setIsCollapsed(_isCollapsed)

          localStorage.setItem('isCollaped', _isCollapsed)
        }}

        // style={{
        //   transform: 'translate(-20px, 14px)',
        //   zIndex: 99999,
        //   backgroundColor: '#fff',
        //   width: '30px',
        //   height: '30px',
        //   padding: 0,
        //   display: 'flex',
        //   alignItems: 'center',
        //   borderRadius: '4px',
        //   justifyContent: 'center',
        //   boxShadow: '0px 8px 14px rgba(15, 42, 81, 0.04)'
        // }}
      >
        {isCollapsed ? (
          <MenuFoldOutlined style={{ fontSize: 20 }} />
        ) : (
          <MenuUnfoldOutlined style={{ fontSize: 20 }} />
        )}
      </div>
      <div style={{fontSize: 22, fontWeight: 500, marginLeft: 20}}>{title}</div>
      <div style={{ marginLeft: 'auto', marginRight: 30 }}>
        {/* <Badge count={3}>
                    <BellOutlined style={{ fontSize: '18px' }} />
                </Badge> */}

        <Dropdown overlay={menu} trigger={['click']}>
          <span
            style={{
              fontSize: '18px',
              marginLeft: '20px',
              cursor: 'pointer'
            }}
          >
            <UserOutlined /> {username}
          </span>
        </Dropdown>
      </div>
    </HeaderAntd>
  )
}
